import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { AddonButton } from '../AddonButton';
import { Base } from '../Base';
import { Heading } from '../Typography/Heading';
import { useDialogContext } from './DialogContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DialogHeader-root_2DTrx",
  "closeWrapper": "DialogHeader-closeWrapper_2Xl3_"
};
function DialogHeader({
  children,
  className,
  ...extraProps
}) {
  const {
    __
  } = useTranslator();
  const {
    labelId,
    close
  } = useDialogContext('DialogHeader');
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "header",
    flexNone: true,
    flex: true,
    gap: "small",
    flexJustifyBetween: true,
    padding: "small",
    borderStartRadius: "1x",
    backgroundColor: "white",
    className: clsx(styles.root, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Heading, {
      id: labelId,
      as: "h3",
      fontSize: "m",
      children: children
    }), /*#__PURE__*/_jsx(Base, {
      flex: true,
      flexShrink0: true,
      flexAlignItemsCenter: true,
      className: styles.closeWrapper,
      children: /*#__PURE__*/_jsx(AddonButton, {
        hitzone: "overlay",
        intent: "remove",
        size: "s",
        onClick: () => {
          close?.();
        },
        children: __('Close')
      })
    })]
  });
}
DialogHeader.displayName = 'DialogHeader';
export { DialogHeader };